import { createSlice } from "@reduxjs/toolkit";
import { BuscaFechamentoFinanceiroModel } from "../../../models/fechamentoFinanceiro/buscaFechamentoFinanceiroModel";
import { FechamentoFinanceiroModel } from "../../../models/fechamentoFinanceiro/fechamentoFinanceiroModel";
import { buscarFechamentoFinanceiro } from "../../../services/fechamentoFinanceiroService";
import { resetAll } from "../../actions/actions";
import { FechamentoFinanceiroDTOModel } from "../../../models/fechamentoFinanceiro/fechamentoFinanceiroDTOModel";

export interface FechamentoFinanceiroState {
  //buscar fechamento financeiro
  loading: boolean;
  busca: BuscaFechamentoFinanceiroModel;
  list: FechamentoFinanceiroDTOModel[];
  entity: FechamentoFinanceiroDTOModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: FechamentoFinanceiroState = {
  //buscar fechamento financeiro
  loading: false,
  busca: {
    idEmpresa: null,
    pesquisar: null,
  } as BuscaFechamentoFinanceiroModel,
  list: [],
  entity: {} as FechamentoFinanceiroDTOModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const fechamentoFinanceiroSlice = createSlice({
  name: "fechamentoFinanceiro",
  initialState,
  reducers: {
    //buscar fechamento financeiro
    setBuscaFechamentoFinanceiro: (state, action) => {
      state.busca = action.payload;
    },
    setEntityFechamentoFinanceiro: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarFechamentoFinanceiro: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarFechamentoFinanceiro: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar fechamento financeiro
    builder.addCase(buscarFechamentoFinanceiro.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarFechamentoFinanceiro.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarFechamentoFinanceiro.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar fechamento financeiro
  setBuscaFechamentoFinanceiro,
  setEntityFechamentoFinanceiro,
  //internal
  setModalCadastrarFechamentoFinanceiro,
  setModalDeletarFechamentoFinanceiro,
} = fechamentoFinanceiroSlice.actions;

export default fechamentoFinanceiroSlice.reducer;
